var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isOpen(_vm.name) || _vm.keepAlive)?_c('div',[_vm._t("default",null,{"modalName":_vm.name,"active":_vm.isActive(_vm.name),"open":_vm.isOpen(_vm.name),"activeId":_vm.getActiveId(_vm.name),"mode":_vm.getMode(_vm.name)})],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }